query colors {
  colors {
    id
    name
    displayName
  }
}
